import React from 'react';
import { Message } from 'semantic-ui-react';

const ErrorMessageList = ({ errorMessages, onDismiss }: ErrorMessageListProps) => {
	return (
		<>
			{ errorMessages?.map((x, index) =>
				<Message key={index} negative compact style={{paddingRight: '3em', marginTop: '0'}} onDismiss={onDismiss && (() => onDismiss(index))}>
					{x}
				</Message>
			)}
		</>
	);
};

interface ErrorMessageListProps {
	errorMessages?: string[];
	onDismiss?: (index: number) => any;
}

export default ErrorMessageList;